import { HStack } from '@chakra-ui/react';

import { Typography } from 'shared';

import { useConfirmationModal } from 'shared/hooks';

export const useChatMessageDeleteConfirmation = ({
  interlocutorName,
  onConfirm,
}: {
  interlocutorName: string;
  onConfirm: () => void;
}) => {
  const content = (
    <HStack gap={1}>
      <Typography color="gray" type="meta">
        This will delete this message for
      </Typography>
      <Typography color="blue" type="meta">
        {interlocutorName}
      </Typography>
    </HStack>
  );

  return useConfirmationModal({
    title: 'Delete message?',
    content,
    onConfirm,
  });
};
